export const regexToSearchWithWildcards = (searchString: string): RegExp =>
  new RegExp(
    searchString.replaceAll(/([.+^$()[\]{}|\\])/g, '\\$1').replaceAll(/([*?])/g, '.$1?'),
    'i',
  );
